import React, {Component} from 'react';
import CONSTANTS from '../../config/constants'
import Illustration from '../../assets/images/timetracker-illustration.png';
import _ from "lodash";

class TimetrackerBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            seconds: 28800,
            completedTime: 0,
            isTicking: false
        };

        this.interval = null;
        this.startTimer = this.startTimer.bind(this);
        this.stopTimer = this.stopTimer.bind(this);
    }

    getContentFieldValue = (fieldDefinitionKey, contents = false) => {
        const {contentFields} = this.props;
        const items = contents ? contents : contentFields;
        const data = _.find(items, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 40;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    startTimer(e) {
        e.preventDefault();

        if (!this.state.isTicking) {
            this.interval = setInterval(() =>
                this.setState({
                    completedTime: this.state.completedTime + 1,
                    isTicking: true
                }), 1000);
        }
    }

    stopTimer(e) {
        e.preventDefault();

        clearInterval(this.interval);
        this.setState({
            isTicking: false
        });
    }

    sec2time(timeInSeconds) {
        var pad = function (num, size) {
                return ('000' + num).slice(size * -1);
            },
            time = parseFloat(timeInSeconds).toFixed(3),
            hours = Math.floor(time / 60 / 60),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60);

        return pad(hours, 2) + 'h ' + pad(minutes, 2) + 'm ' + pad(seconds, 2) + 's';
    }

    render() {
        const data = {
            title: this.getContentFieldValue('Title'),
            illustration: Illustration,
            start: 'Start time',
            stop: 'Stop time',
            textOne: 'Worked today',
            textTwo: 'Time left',
        };

        return (
            <section className={"timetracker-block w--" + this.getBlockWidth() + " show--shadow"}>
                <div className="title-section">
                    <h3>{data.title}</h3>
                </div>
                <div className="content">
                    <figure className="illustration">
                        <img src={data.illustration} alt={data.title}/>
                    </figure>

                    <button
                        className="startTimer"
                        onClick={(e) => this.startTimer(e)}
                    >
                        {data.start}
                    </button>
                    <button
                        className="stopTimer"
                        onClick={(e) => this.stopTimer(e)}
                    >
                        {data.stop}
                    </button>
                    <div className="timers">
                        <em>{data.textOne}:</em>
                        <span className="time-spent">
							{this.sec2time(this.state.completedTime)}
						</span>
                        <em>{data.textTwo}:</em>
                        <span className="time-left">
							{this.sec2time(this.state.seconds - this.state.completedTime)}
						</span>
                    </div>
                </div>
            </section>
        );
    }
}

export default TimetrackerBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/TimetrackerBlock.js